import { TDeviceType } from '@cian/ui-kit';

interface IPageExtra {
  banner_type?: 'footer' | 'listing';
}

export interface IGetAnalyticsPageParams {
  pageNumber?: number;
  deviceType: TDeviceType;
  extra?: IPageExtra;
}

export const getPageData = ({ pageNumber, deviceType, extra = {} }: IGetAnalyticsPageParams) => {
  return {
    pageType: 'ListingCB',
    siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    pageNumber,
    extra,
  };
};
